module.exports = __webpack_public_path__ + "static/img/honor-8.ff6efe3.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-8.png
// module id = XSSM
// module chunks = 0